module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/duplexify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 212
// module chunks = 0